module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-presale u-relative"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p-presale__header-container u-marg-x-auto u-w8of12 u-w10of12@sm"
  }, [_c('h1', {
    staticClass: "p-presale__header-container__title u-color--white t-fweight--light"
  }, [_vm._v("Presale event is live.")]), _vm._v(" "), _c('div', {
    staticClass: "p-presale__header-container__countdown-container u-marg-t-xl"
  }, [_c('app-countdown', {
    class: [_vm.$root.isFirstLoading ? 'is-first-loading-presale' : ''],
    attrs: {
      "dateDeadline": _vm.$root.content.global.countdown.deadlineEnd,
      "use0Before": _vm.$root.content.global.countdown.use0Before
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-presale__header-container__countdown-container__title u-relative t-ffamily--simplon t-fweight--medium u-uppercase u-color--white"
  }, [_vm._v("Token sale ends on October 15th.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-presale__header-container__contribute-container u-marg-t-lg"
  }, [_c('app-button', {
    staticClass: "p-presale__header-container__contribute-container__button is-white u-inline-block u-uppercase t-fsize--xs t-weight--bold"
  }, [_vm._v("\n                Contribute\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-presale__maximum-container u-relative u-w10of12 u-fit-w@sm u-pad-x-w2of12 u-pad-x-w1of12@sm"
  }, [_c('h3', {
    staticClass: "p-presale__maximum-container__title u-relative u-zindex--2 u-color--white u-lheight--150p"
  }, [_vm._v("PRAX will be hard-capped at 100M tokens with 4m committed through our pre-sale.")]), _vm._v(" "), _vm._l((_vm.maximumListItems), function(items, index) {
    return _c('div', {
      staticClass: "p-presale__maximum-container__list u-relative u-zindex--2 u-marg-t-xl u-flex u-flex-fd--column@sm u-flex-jc--space-between"
    }, _vm._l((items), function(item, index) {
      return _c('div', {
        staticClass: "p-presale__maximum-container__list__item u-marg-t-0 u-marg-t-md@sm u-w1of4 u-fit-w@sm"
      }, [_c('div', {
        staticClass: "p-presale__maximum-container__list__item__title u-color--white u-lheight--150p",
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "p-presale__maximum-container__list__item__content o-content u-marg-t-xs u-color--white u-lheight--150p"
      }, [_c('p', {
        staticClass: "u-opacity--40",
        domProps: {
          "innerHTML": _vm._s(item.content)
        }
      })])])
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "p-presale__maximum-container__background u-absolute u-zindex--1 u-pos-tl u-fit u-bg--brand-primary"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-presale__maximum-container__border-bottom u-absolute u-zindex--2 u-pos-bl u-fit-w u-bg--white u-opacity--25"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "p-presale__token-allocation-container u-relative u-w10of12 u-fit-w@sm u-pad-r-w2of12 u-pad-x-w1of12@sm u-bg--brand-primary"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "p-presale__token-allocation-container__canvas-container js-token-allocation-container u-relative u-marg-t-xl@sm u-zindex--1"
  }, [_c('app-token-allocation-graphic', {
    attrs: {
      "data": _vm.tokenAllocationItems
    }
  })], 1)]), _vm._v(" "), _c('app-newsletter'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-presale__transition u-absolute u-pos-tl u-zindex--1 u-fit-w u-viewport-fit-h u-bg--brand-primary u-overflow-h"
  }, [_c('div', {
    staticClass: "p-presale__transition__percent u-absolute u-pos-r-vw1of12 u-color--white"
  }, [_c('span', [_vm._v("100")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "p-presale__token-allocation-container__title u-absolute u-relative@sm u-zindex--2 u-inline-block u-color--white t-fweight--light"
  }, [_c('span', {
    staticClass: "p-presale__token-allocation-container__title-number u-absolute u-hide@sm t-fsize--sm t-fweight--medium t-ffamily--simplon"
  }, [_vm._v("01")]), _vm._v(" "), _c('span', {
    staticClass: "u-lheight--150p"
  }, [_c('div', [_vm._v("Token")]), _vm._v(" "), _c('div', [_vm._v("Allocation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-609e6dde"}!./src/scripts/components/page-presale/template.html
// module id = 469
// module chunks = 0